import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["navigationSelectorParams", "onOptionSelect", "separator", "onChange", "onRenderSelectedValue", "onClick", "enableSelectAllOption", "enableSearchOption", "enablePortal", "zIndex"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useState, useRef } from 'react';
import { useDetectClickOutsideComponent, useDetectEscapeKeyPressed, useOnValueUpdate, useOptions, useSelectedValueToDisplay, useValue } from '../../../../utils';
import { useOverlay, usePopper, useRootRef } from '../../../../system';
export var useHeaderNavigationSelector = function useHeaderNavigationSelector(_ref, ref) {
  var _ref$navigationSelect = _ref.navigationSelectorParams,
      _ref$navigationSelect2 = _ref$navigationSelect.label,
      label = _ref$navigationSelect2 === void 0 ? 'Country' : _ref$navigationSelect2,
      value = _ref$navigationSelect.value,
      defaultValue = _ref$navigationSelect.defaultValue,
      options = _ref$navigationSelect.options,
      formatOption = _ref$navigationSelect.formatOption,
      isMultiselect = _ref$navigationSelect.isMultiselect,
      isExpanded = _ref$navigationSelect.isExpanded,
      disabled = _ref$navigationSelect.disabled,
      onOptionSelect = _ref.onOptionSelect,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? true : _ref$separator,
      onChange = _ref.onChange,
      onRenderSelectedValue = _ref.onRenderSelectedValue,
      onClick = _ref.onClick,
      enableSelectAllOption = _ref.enableSelectAllOption,
      enableSearchOption = _ref.enableSearchOption,
      enablePortal = _ref.enablePortal,
      zIndex = _ref.zIndex,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var dropdownRef = useRef(null);
  var containerRef = useRootRef(ref);

  var _useValue = useValue(value, defaultValue),
      _useValue2 = _slicedToArray(_useValue, 2),
      internalValue = _useValue2[0],
      setInternalValue = _useValue2[1];

  var _useOptions = useOptions(options, formatOption),
      internalOptions = _useOptions.internalOptions,
      isFlat = _useOptions.isFlat;

  var onValueUpdate = useOnValueUpdate(setInternalValue, onOptionSelect, onChange);
  var selectedValueToDisplay = useSelectedValueToDisplay(internalValue, internalOptions, onRenderSelectedValue);

  var _useState = useState(isExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      isOptionListShown = _useState2[0],
      setIsOptionListShown = _useState2[1];

  var _usePopper = usePopper(dropdownRef, containerRef, {
    align: 'bottom-end',
    offset: [0, 0],
    allowedAutoPlacements: ['bottom']
  }),
      panelProps = _usePopper.panelProps;

  var _useOverlay = useOverlay(isOptionListShown, {
    zIndex: zIndex
  }),
      realZIndex = _useOverlay.zIndex;

  useDetectClickOutsideComponent(containerRef, setIsOptionListShown, isOptionListShown);
  useDetectEscapeKeyPressed(containerRef, setIsOptionListShown, isOptionListShown);
  var handleClick = useCallback(function (event) {
    setIsOptionListShown(!isOptionListShown);

    if (onClick) {
      onClick(event);
    }
  }, [setIsOptionListShown, isOptionListShown, onClick]);
  var handleEnterKeyDown = useCallback(function (event) {
    var key = event.key;

    if (key === 'Enter' && setIsOptionListShown) {
      setIsOptionListShown(!isOptionListShown);
    }
  }, [setIsOptionListShown, isOptionListShown]);
  return {
    rootProps: restProps,
    optionListProps: {
      multiple: isMultiselect,
      formatOption: formatOption,
      internalValue: internalValue,
      onValueUpdate: onValueUpdate,
      isFlat: isFlat,
      options: options,
      internalOptions: internalOptions,
      isOptionListShown: isOptionListShown,
      setIsOptionListShown: setIsOptionListShown,
      disabled: disabled,
      enableSelectAllOption: enableSelectAllOption,
      enableSearchOption: enableSearchOption
    },
    expansionIndicatorProps: {
      isExpanded: isOptionListShown
    },
    selectorProps: {
      separator: separator,
      onClick: handleClick,
      onKeyDown: handleEnterKeyDown,
      tabIndex: 0,
      isOptionListShown: isOptionListShown
    },
    containerRef: containerRef,
    label: label,
    selectedValueToDisplay: selectedValueToDisplay,
    portalProps: {
      enablePortal: enablePortal
    },
    listContainerProps: _objectSpread({
      ref: dropdownRef,
      zIndex: realZIndex
    }, panelProps)
  };
};